import { useEffect, useState } from "react";
import Campo from "../../../components/Campo";
import { Membro } from "../../../model/Membro";
import styles from "./styles.module.css";
import { cepMask, cpfMask, numberMask } from "../../../controllers/Masks";
import { useMask } from "@react-input/mask";
import VerificaForm from "../../../controllers/VerificaForm";
import CampoDate from "../../../components/Campo/CampoDate";
import CampoSelect from "../../../components/Campo/CampoSelect";
import listarCidades from "../../../services/listarCidades";

type Props = {
  passarPagina: Function;
  setMembro: React.Dispatch<React.SetStateAction<Membro | undefined>>;
};

function CadastroRepresentante({ passarPagina, setMembro }: Props) {
  const [nomeRepresentante, setNome] = useState("");
  const [cpfRepresentante, setCpf] = useState("");
  const [orgaoRepresentante, setOrgao] = useState("");
  const [rgRepresentante, setRg] = useState("");
  const [emailRepresentante, setEmail] = useState("");
  const [cargoRepresentante, setCargo] = useState("");

  const [inicioMandato, setInicio] = useState(new Date(Date.now()));
  const [fimMandato, setFim] = useState(new Date(Date.now()));

  const [cepEndereco, setCep] = useState("79200-000");
  const [numeroEndereco, setNumero] = useState("");
  const [ruaEndereco, setRua] = useState("");
  const [bairroEndereco, setBairro] = useState("");
  const [cidadeEndereco, setCidade] = useState("Aquidauana");
  const [estadoEndereco, setEstado] = useState("MS");
  const [complementoEndereco, setComplemento] = useState("");

  const [listaCidades, setListaCidades] = useState(["", "Aquidauana"]);

  useEffect(() => {
    const atualizarListaCidades = async () => {
      try {
        const response = await listarCidades(estadoEndereco);
        const cidades = response.map((c: any) => {
          return c.nome;
        });

        setListaCidades(cidades);
        if (estadoEndereco === "MS") {
          setCidade("Aquidauana");
        } else {
          setCidade(listaCidades[0]);
        }
      } catch (error) {
        console.error("Erro ao buscar cidades:", error);
      }
    };
    atualizarListaCidades();
  }, [estadoEndereco]);

  return (
    <>
      <h2>
        2. Cadastre Informações sobre o <strong>Representante Legal</strong> da
        Instituição
      </h2>
      <hr className={styles.separador} />
      <h3 className={styles.subTitulo}>Dados do Representante:</h3>
      <div className={styles.gridCampos}>
        <Campo
          title="Nome do Representante Legal"
          type="text"
          placeholder="Nome completo do Representante"
          maxLength={64}
          required={true}
          customValidity="Preencha com o Nome do Representante legal"
          setter={setNome}
          value={nomeRepresentante}
        ></Campo>

        <Campo
          title="CPF"
          type="text"
          placeholder="000.000.000-00"
          minLength={14}
          required={true}
          customValidity="Preencha com o cpf do seu Representante legal"
          setter={setCpf}
          value={cpfRepresentante}
          mask={useMask(cpfMask)}
        ></Campo>

        <Campo
          title="Órgão"
          type="text"
          placeholder="Órgão expeditor do seu RG"
          maxLength={8}
          required={true}
          customValidity="Preencha com o órgão expeditor do RG"
          setter={setOrgao}
          value={orgaoRepresentante}
        ></Campo>

        <Campo
          title="RG"
          type="text"
          placeholder="RG do representante"
          maxLength={18}
          required={true}
          customValidity="Digite o RG do Representante legal"
          setter={setRg}
          value={rgRepresentante}
        ></Campo>

        <Campo
          title="E-mail"
          type="email"
          placeholder="representante@gmail.com"
          maxLength={64}
          required={true}
          customValidity="Preencha com o email de contato do Representante legal"
          setter={setEmail}
          value={emailRepresentante}
        ></Campo>

        <Campo
          title="Cargo"
          type="text"
          placeholder="cargo do representante"
          maxLength={64}
          required={true}
          customValidity="Preencha com o cargo do seu Representante legal"
          setter={setCargo}
          value={cargoRepresentante}
        ></Campo>
        <CampoDate
          title="Inicio do Mandato"
          showAsterisk
          setter={setInicio}
          max={new Date(Date.now()).toISOString().split("T")[0]}
          value={inicioMandato}
        ></CampoDate>
        <CampoDate
          title="Fim do Mandato"
          showAsterisk
          min={new Date(Date.now()).toISOString().split("T")[0]}
          setter={setFim}
          value={fimMandato}
        ></CampoDate>
      </div>
      <hr className={styles.separador} />
      <h3 className={styles.subTitulo}>Endereço do Representante:</h3>
      <div className={styles.gridCampos}>
        <Campo
          title="CEP"
          type="text"
          placeholder="00000-000"
          minLength={9}
          required={true}
          customValidity="Preencha com o CEP da sua Instituição"
          setter={setCep}
          value={cepEndereco}
          mask={useMask(cepMask)}
        ></Campo>
        <CampoSelect title="Estado" setter={setEstado} value={estadoEndereco}>
          <option value="AC">Acre (AC)</option>
          <option value="AL">Alagoas (AL)</option>
          <option value="AP">Amapá (AP)</option>
          <option value="AM">Amazonas (AM)</option>
          <option value="BA">Bahia (BA)</option>
          <option value="CE">Ceará (CE)</option>
          <option value="DF">Distrito Federal (DF)</option>
          <option value="ES">Espírito Santo (ES)</option>
          <option value="GO">Goiás (GO)</option>
          <option value="MA">Maranhão (MA)</option>
          <option value="MT">Mato Grosso (MT)</option>
          <option value="MS">Mato Grosso do Sul (MS)</option>
          <option value="MG">Minas Gerais (MG)</option>
          <option value="PA">Pará (PA)</option>
          <option value="PB">Paraíba (PB)</option>
          <option value="PR">Paraná (PR)</option>
          <option value="PE">Pernambuco (PE)</option>
          <option value="PI">Piauí (PI)</option>
          <option value="RJ">Rio de Janeiro (RJ)</option>
          <option value="RN">Rio Grande do Norte (RN)</option>
          <option value="RS">Rio Grande do Sul (RS)</option>
          <option value="RO">Rondônia (RO)</option>
          <option value="RR">Roraima (RR)</option>
          <option value="SC">Santa Catarina (SC)</option>
          <option value="SP">São Paulo (SP)</option>
          <option value="SE">Sergipe (SE)</option>
          <option value="TO">Tocantins (TO)</option>
        </CampoSelect>
        <CampoSelect title="Cidade" setter={setCidade} value={cidadeEndereco}>
          {listaCidades &&
            listaCidades.map((cidade, index) => (
              <option value={cidade} key={index}>
                {cidade}
              </option>
            ))}
        </CampoSelect>
        <Campo
          title="Bairro"
          type="text"
          placeholder="Bairro do seu Representante"
          maxLength={64}
          required={true}
          customValidity="Preencha com o Bairro da sua Instituição"
          setter={setBairro}
          value={bairroEndereco}
        ></Campo>
        <Campo
          title="Rua"
          type="text"
          placeholder="Rua do seu Representante"
          maxLength={64}
          required={true}
          customValidity="Preencha com a rua da sua Instituição"
          setter={setRua}
          value={ruaEndereco}
        ></Campo>
        <Campo
          title="Numero"
          type="text"
          placeholder="Numero do Imóvel do seu Representante"
          required={true}
          customValidity="Preencha com o numero do Imóvel"
          setter={setNumero}
          value={numeroEndereco}
          mask={useMask(numberMask)}
        ></Campo>
        <Campo
          title="Complemento"
          type="text"
          placeholder="Complemento do Imóvel"
          maxLength={128}
          required={false}
          customValidity="Preencha com o Complemento"
          setter={setComplemento}
          value={complementoEndereco}
        ></Campo>
      </div>
      <div className="flex justify-between">
        <button
          className={styles.passarTelaBtn}
          onClick={(e) => {
            e.preventDefault();
            passarPagina(0);
          }}
        >
          ❮❮ Anterior
        </button>
        <button
          className={styles.passarTelaBtn}
          onClick={(e) => {
            if (VerificaForm(e.currentTarget.form)) {
              setMembro({
                nome: nomeRepresentante,
                cpf: cpfRepresentante,
                orgao: orgaoRepresentante,
                rg: rgRepresentante,
                email: emailRepresentante,
                cargo: cargoRepresentante,
                representante: true,
                data_inicio_mandato: inicioMandato,
                data_fim_mandato: fimMandato,
                endereco: {
                  cep: cepEndereco,
                  estado: estadoEndereco,
                  cidade: cidadeEndereco,
                  bairro: bairroEndereco,
                  rua: ruaEndereco,
                  numero: numeroEndereco,
                  complemento: complementoEndereco,
                },
              });
              passarPagina(2);
            }
          }}
        >
          Proximo ❯❯
        </button>
      </div>
    </>
  );
}

export default CadastroRepresentante;
